export function getString(entry, condition) {
  if (typeof entry === 'string') return condition ? entry : undefined;

  return entry
    .reduce((values, item) => {
      if (item.condition) values.push(item.value);

      return values;
    }, [])
    .join(' ');
}

export function cn(...args) {
  return args
    .flatMap((arg) =>
      typeof arg === 'string'
        ? arg
        : typeof arg === 'object'
          ? Object.entries(arg)
              .filter(([_, val]) => val)
              .map(([key]) => key)
          : []
    )
    .filter(Boolean)
    .join(' ');
}

export function insertSoftHyphen(text, original, softHyphenated) {
  return text.replace(original, softHyphenated);
}

export function capitalizeFirstLetter(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
